import { CASES } from './constants';

const initialState = {
    calculations: [],
    filterForm: {
        jobId: '',
        loadStatus: '',
    },
    selectedJob: [],
    showCalculations: false,
    loadStatusOptions: [],
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    filterParam: '',
    rangeParam: [0, 24],
    sortParam: ['id', 'DESC'],
    defaultFilterRange: [0, 19],
    itemsPerPage: 25,
};

export function dateMathCalculations(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_DATE_MATH_CALCULATIONS: {
            return { ...state, ...payload };
        }
        case CASES.UPDATE_DATE_MATH_CALCULATIONS_SEARCH_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_DATE_MATH_CALCULATIONS: {
            return {
                ...initialState,
                jobStatusOptions: state.jobStatusOptions,
            };
        }
        default:
            return state;
    }
}
